import React, { useState, useEffect } from "react";
import RootRoute from "./comp/RootRoute"; // <-- Novo componente
import { AuthProvider } from "./context/AuthContext";
import {
  Route,
  Routes,
  Router,
  useNavigate,
  Navigate,
  BrowserRouter,
} from "react-router-dom";

import Inicio from "./paginas/Inicio";
import Page404 from "./paginas/Page404";
import Funcoes from "./paginas/Funcoes";
import Entrar from "./paginas/Entrar";
import Cadastro from "./paginas/Cadastro";
import RecuperSenha from "./paginas/RecuperSenha";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./paginas/Dashboard";

import D404 from "./paginas/Dashboard/404";

import HeaderDash from "./comp/Header";
import Lojas from "./paginas/Lojas";
import Produtos from "./paginas/Produtos";
import Categorias from "./paginas/Categorias";
import CategoriasDelivery from "./paginas/Categorias/CategoriasDelivery";
import AdicionarProduto from "./paginas/Produtos/AdicionarProduto";
import Atributos from "./paginas/Produtos/Atributos";
import PDV from "./PDV";
import CadastrarProduto from "./PDV/CadastrarProduto";
import EditarProduto from "./paginas/EditarProduto";
import BasicProductEdit from "./paginas/BasicProductEdit";
import EditPhotosProduct from "./paginas/EditPhotosProduct";
import EditPriceProduct from "./paginas/EditPriceProduct";
import EditProductsAttributes from "./paginas/EditProductsAttributes";
import Delivery from "./paginas/Delivery";
import CadastroLoja from "./paginas/Lojas/CadastroLoja";
import AppLoja from "./paginas/AppLoja";

/*
import DeliveryPage from "./DeliveryPage";
import DeliveryLayout from "./DeliveryPage/pages/DeliveryLayout";
import CartPage from "./DeliveryPage/pages/CartPage";
import MenuPage from "./DeliveryPage/pages/MenuPage";
import InfoPage from "./DeliveryPage/pages/InfoPage";

import LoginPage from "./paginas/LoginPage";

  */



import ProtectedRoute from "./comp/ProtectedRoute";
import PublicRoute from "./comp/PublicRoute";
import AuthRegister from "./paginas/AuthRegister";
import Appearance from "./paginas/Appearance";
import Settings from "./paginas/Settings";
import { ColorModeProvider } from "./context/ThemeContext";
import MyLink from "./paginas/MyLink";
import SubscriptionManager from "./paginas/SubscriptionManager";
import ListProducts from "./paginas/ListProducts";
import NovoProduto from "./paginas/NovoProduto";
import Orders from "./paginas/Orders";
import Tools from "./paginas/Tools";
import Reports from "./paginas/Reports";
import SupportPage from "./paginas/SupportPage";
import { Box } from "@mui/material";
import error404 from "../src/images/404.svg";
import Sellers from "./paginas/Sellers";
import Clients from "./paginas/Clients";
import CheckList from "./paginas/Checklist";
import ChecklistNew from "./paginas/ChecklistNew";
import ChecklistView from "./paginas/ChecklistView";
import GerenciamentoMesas from "./paginas/GerenciamentoMesas";
import { TelaGarcom } from "./paginas/Restaurante/TelaGarcom";
import PaginaCaixas from "./paginas/PaginaCaixas";
import Conta from "./FoodDeliveryPage/Conta";
import PerfisDeAcesso from "./paginas/PerfisDeAcesso";
import AvaliacoesScreen from "./paginas/AvaliacoesScreen";
import ExtrasPage from "./paginas/ExtrasPage";
import TelaCompras from "./paginas/TelaCompras";
import Box2 from "./paginas/Box2";
import DispositivosPage from "./paginas/Devices";
import FazPedidoPrivacyPolicy from "./paginas/Inicio/FazPedidoPrivacyPolicy";
import FazPedidoTermsOfService from "./paginas/Inicio/FazPedidoTermsOfService";
import FazPedidoAboutUs from "./paginas/Inicio/FazPedidoAboutUs";
import LeadCapturePage from "./paginas/Inicio/LeadCapturePage";
import EditProductsAttributes2 from "./paginas/EditProductsAttributes2";
import BannersConfig from "./paginas/Appearance/BannersConfig";
import LiveStreamLojista from "./paginas/LiveStreamLojista";
import ProductVariationsManager from "./paginas/Produtos/ProductVariationsManager";

import CatalogoDigitalPage from "./paginas/Inicio/modulos";
import FazPedidoModuloPDVPage from "./paginas/Inicio/modulos/FazPedidoModuloPDVPage"
import FazPedidoModuloEstoquePage from "./paginas/Inicio/modulos/FazPedidoModuloEstoquePage"
import FazPedidoSolucaoImpressaoPage from "./paginas/Inicio/modulos/FazPedidoSolucaoImpressaoPage"
import CardapioDigitalRecifePage from "./paginas/Inicio/estados/CardapioDigitalRecifePage"
import CuritibaSEOPage from "./paginas/Inicio/estados/CuritibaSEOPage"




function App() {
  return (
    <BrowserRouter>
      <ColorModeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route element={<PublicRoute />}>
              <Route path="/auth/login" element={<Entrar />} />
              <Route path="/auth/login/:store" element={<Conta />} />
              <Route path="/auth/register" element={<AuthRegister />} />
              <Route path="/terms" element={<FazPedidoTermsOfService />} />
              <Route path="/privacy" element={<FazPedidoPrivacyPolicy />} />
              <Route path="/about" element={<FazPedidoAboutUs />} />
              <Route path="/demo/watch" element={<LeadCapturePage />} />
              <Route path="/solucoes/catalogo-digital" element={<CatalogoDigitalPage />} />
              <Route path="/solucoes/pdv-frente-de-caixa" element={<FazPedidoModuloPDVPage />} />
              <Route path="/solucoes/controle-de-estoque" element={<FazPedidoModuloEstoquePage />} />
              <Route path="/solucoes/impressao-termica" element={<FazPedidoSolucaoImpressaoPage />} />
              <Route path="/cardapio-digital-em-recife" element={<CardapioDigitalRecifePage />} />
              <Route path="/cardapio-digital-em-curitiba" element={<CuritibaSEOPage />} />
              <Route path="*" element={<>404</>} />
            </Route>
            <Route element={<ProtectedRoute />}>

              <Route path="/delivery" element={<Delivery />} />
              <Route path="/live" element={<LiveStreamLojista />} />
              <Route path="/access-profiles" element={<PerfisDeAcesso />} />
              <Route path="/reviews" element={<AvaliacoesScreen />} />

              <Route path="/addons" element={<ExtrasPage />} />

              <Route path="/devices" element={<DispositivosPage />} />

              <Route path="/purchases" element={<TelaCompras />} />


              <Route path="/checklist" element={<CheckList />} />
              <Route path="/checklist/new" element={<ChecklistNew />} />
              <Route path="/checklist/entrada/:uuid" element={<ChecklistView />} />


              <Route path="/tables" element={<GerenciamentoMesas />} />

              <Route path="/settings/*" element={<Settings />} />
              <Route path="/appearance" element={<Appearance />} />
              <Route path="/appearance/banners" element={<BannersConfig />} />
              <Route path="/lojas" element={<Lojas />} />
              <Route path="/lojas/cadastro" element={<CadastroLoja />} />
              <Route path="/vender" element={<PDV />} />
              {/*  <Route path="/produtos" element={<Produtos />} /> */}
              <Route path="/produtos" element={<ListProducts />} />
              {/*    <Route path="/produtos/novo" element={<AdicionarProduto />} /> */}
              <Route path="/produtos/novo" element={<NovoProduto />} />
              <Route path="/produtos/:uuid/editar" element={<EditarProduto />} />
              <Route path="/produtos/:uuid/basic" element={<BasicProductEdit />} />
              <Route path="/produtos/:uuid/photos" element={<EditPhotosProduct />} />
              <Route path="/produtos/:uuid/price" element={<EditPriceProduct />} />
              <Route path="/produtos/:uuid/attributes" element={<EditProductsAttributes />} />
              <Route path="/produtos/:uuid/attributes2" element={<EditProductsAttributes2 />} />
              <Route path="/produtos/:uuid/attributes3" element={<ProductVariationsManager />} />


              <Route path="/box" element={<Box2 />} />
              <Route path="/box2" element={<Box2 />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/categories" element={<Categorias />} />
              <Route path="/link" element={<MyLink />} />
              <Route
                path="/produtos/categorias/delivery"
                element={<CategoriasDelivery />}
              />
              <Route path="/clients" element={<Clients />} />
              <Route path="/sellers" element={<Sellers />} />
              <Route path="/reports" element={<Reports />} />

              <Route path="/tools" element={<Tools />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="*" element={<>404</>} />
            </Route>
          </Routes>
        </AuthProvider>
      </ColorModeProvider>
      <ToastContainer />

    </BrowserRouter>
  );
}

export default App;
